/**
 * CopyButton — copies a value to the clipboard and confirms with a toast.
 * Sized in `em`, so it matches whatever text it sits next to.
 */
import { Copy } from 'lucide-react';

import { useToast } from '../../shared/toast/toastContext';

export function CopyButton({
  value,
  what,
}: {
  value: string;
  /** What is being copied, e.g. "card number". Used in the label and toast. */
  what: string;
}) {
  const { showToast } = useToast();
  const label = `Copy ${what}`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      showToast({ message: `${what.charAt(0).toUpperCase()}${what.slice(1)} copied` });
    } catch {
      showToast({ message: `Could not copy the ${what}`, tone: 'error' });
    }
  }

  return (
    <button
      type="button"
      className="nb-btn nb-btn-ghost"
      onClick={() => void copy()}
      aria-label={label}
      title={label}
      style={{ fontSize: 'inherit', height: '1.9em', padding: '0 0.47em', flex: '0 0 auto' }}
    >
      <Copy size="0.9em" aria-hidden="true" />
    </button>
  );
}
